import { ResultOptions } from "@design-controls/types";

export const ResultValueToLabel: { [key in ResultOptions]: string } = {
  passed: "Passed",
  failed: "Failed",
  blocked: "Blocked",
};
